// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { createAction } from 'redux-actions'
import { CachedRoomPermissions } from './types'
import { dispatch, getState } from '$setup/redux'

export type UserPermissionsStorage = Record<string, CachedRoomPermissions>
const initialState: UserPermissionsStorage = {}

// actions
const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS'
const setUserPermissions = createAction(SET_USER_PERMISSIONS)

const RESET_USER_PERMISSIONS = 'RESET_USER_PERMISSIONS'
const resetUserPermissions = createAction(RESET_USER_PERMISSIONS)

const UPDATE_ROOM_USER_PERMISSIONS = 'UPDATE_ROOM_USER_PERMISSIONS'
const updateRoomUserPermissions = createAction(UPDATE_ROOM_USER_PERMISSIONS)

export const userPermissionsStorage = {
  get: () => getState().main.userPermissions as UserPermissionsStorage,

  set: (permissions: UserPermissionsStorage) =>
    dispatch(setUserPermissions(permissions)),

  reset: () => dispatch(resetUserPermissions()),

  updateRoom: (roomId: string, update: Partial<CachedRoomPermissions>) =>
    dispatch(updateRoomUserPermissions({ roomId, update })),
}

// reducers
const reducers = {
  [SET_USER_PERMISSIONS]: (
    state: UserPermissionsStorage,
    permissions: UserPermissionsStorage,
  ) => ({ ...state, ...permissions }),

  [RESET_USER_PERMISSIONS]: () => initialState,

  [UPDATE_ROOM_USER_PERMISSIONS]: (
    state: UserPermissionsStorage,
    {
      roomId,
      update,
    }: { roomId: string; update: Partial<CachedRoomPermissions> },
  ) => ({
    ...state,
    [roomId]: { ...state[roomId], ...update },
  }),
}

export const userPermissionsReducer = (
  state = initialState,
  { type, payload }: { type: keyof typeof reducers; payload: any },
) => (reducers[type] ? reducers[type](state, payload) : state)
